import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Box from "@material-ui/core/Box"
import IconButton from "@material-ui/core/IconButton"
import Facebook from "@material-ui/icons/Facebook"
import Twitter from "@material-ui/icons/Twitter"
import Instagram from "@material-ui/icons/Instagram"
import YouTube from "@material-ui/icons/YouTube"
import LinkedIn from "@material-ui/icons/LinkedIn"
import GitHub from "@material-ui/icons/GitHub"

const SocialButtons = props => {
  const data = useStaticQuery(graphql`
    query SocialQuery {
      site {
        siteMetadata {
          social {
            twitter
            facebook
            instagram
            linkedIn
            youtube
            github
          }
        }
      }
    }
  `)
  const { social } = data.site.siteMetadata

  return (
    <Box style={{ paddingLeft: 12, flexDirection: "row", display: "flex" }}>
      <IconButton
        aria-label="social-fb"
        id="lkd-btn-footer"
        href={social.linkedIn}
        target={"_blank"}
        rel="noopener"
        style={{
          boxShadow: "0 0 0",
          padding: props.blog && 4,
          color: props.fromLanding && "#FFF",
        }}
      >
        <LinkedIn />
      </IconButton>
      <IconButton
        aria-label="social-fb"
        id="fb-btn-footer"
        href={social.facebook}
        target={"_blank"}
        rel="noopener"
        style={{
          boxShadow: "0 0 0",
          padding: props.blog && 4,
          color: props.fromLanding && "#FFF",
        }}
      >
        <Facebook />
      </IconButton>
      <IconButton
        aria-label="social-fb"
        id="inst-btn-footer"
        href={social.instagram}
        target={"_blank"}
        rel="noopener"
        style={{
          boxShadow: "0 0 0",
          padding: props.blog && 4,
          color: props.fromLanding && "#FFF",
        }}
      >
        <Instagram />
      </IconButton>
      <IconButton
        aria-label="social-fb"
        id="twtr-btn-footer"
        href={social.twitter}
        target={"_blank"}
        rel="noopener"
        style={{
          boxShadow: "0 0 0",
          padding: props.blog && 4,
          color: props.fromLanding && "#FFF",
        }}
      >
        <Twitter />
      </IconButton>
      {props.youtube && (
        <IconButton
          aria-label="social-yt"
          id="yt-btn-footer"
          href={social.youtube}
          target={"_blank"}
          rel="noopener"
          style={{
            boxShadow: "0 0 0",
            padding: props.blog && 4,
            color: props.fromLanding && "#FFF",
          }}
        >
          <YouTube />
        </IconButton>
      )}
      <IconButton
        aria-label="social-fb"
        id="git-btn-footer"
        href={social.github}
        target={"_blank"}
        rel="noopener"
        style={{
          boxShadow: "0 0 0",
          padding: props.blog && 4,
          color: props.fromLanding && "#FFF",
        }}
      >
        <GitHub />
      </IconButton>
    </Box>
  )
}

export default SocialButtons
